import * as React from "react";

type Props = {
  title?: string;
  children: React.ReactNode;
};

export const Card: React.FC<Props> = (props) => (
  <div className="c-card" style={{ padding: "1.5rem 1rem" }}>
    <h2
      className="has-text-centered has-text-weight-bold mb-4"
      style={{ fontSize: "1rem", lineHeight: "1.7" }}
    >
      {props.title}
    </h2>
    {props.children}
  </div>
);
